<template>
    <div class="agreement_box" v-loading="loading">
        <el-dialog title="取消订单" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box1"  v-loading="loading">
                <div class="imgs1">
                    <img src="../../assets/img/user_info/user_order/icon1.png" alt="">
                </div>
                <div class="text1">是否确认取消订单</div>
                <div class="btn_flex">
                    <div class="btns1" @click="handle_end1">确认</div>
                    <div class="btns2" @click="dialogVisible=false">取消</div>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="取消订单" :visible.sync="dialogVisible2" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose2">
            <div class="dialog_box2">
                <div class="imgs1">
                    <img src="../../assets/img/user_info/user_order/icon2.png" alt="">
                </div>
                <div class="text1">取消成功</div>
                <!-- <div class="text1">正由后台进行审核</div> -->
                <div class="btn_flex">
                    <div class="btns1" @click="handle_end2">返回</div>
                    <div class="btns2" @click="handle_end2">确认</div>
                </div>
            </div>
        </el-dialog> 
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            dialogVisible:false,//显示隐藏
            dialogVisible2:false,
           
            
           
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {

    },
    methods: {
        handleClose(){
            this.dialogVisible=false
        },
        handleClose2(){
            this.dialogVisible2=false

        },
        handle_end1(){
            this.loading = true
            this.$api("qxOrder", {
                id:this.$route.query.id
			}, "post").then((res) => {
                this.loading = false
                console.log('订单详情',res)
                if (res.code == 1) {
                    alertSucc('取消成功')
                    this.dialogVisible=false
                    this.dialogVisible2=true   
                    this.$emit('handle_qx_end')
                } else {
                    alertErr(res.msg)
                }
            });
            


           
        },
        handle_end2(){
            this.dialogVisible2=false
        },
        handle_open(){
            this.dialogVisible=true
        }



    },

}
</script>
<style scoped lang="less">
.agreement_box {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 580px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box1{
                    .imgs1{
                        padding-top: 30px;
                        display: flex;
                        // align-items: center;
                        justify-content: center;
                        img{
                            width: 62px;
                        }
                    }
                    .text1{
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 18px;
                        color: #999999;
                        text-align: center;
                    }
                   
                   
                    .btn_flex{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 67px;
                        .btns1{
                            width: 128px;
                            height: 40px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            cursor: pointer;
                            text-align: center;
                            line-height: 40px;
                        }
                        .btns2{
                            width: 128px;
                            height: 40px;
                            background: #377CFD;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-left: 20px;
                        }
                    }
                }
                .dialog_box2{
                    .imgs1{
                        padding-top: 30px;
                        display: flex;
                        // align-items: center;
                        justify-content: center;
                        img{
                            width: 62px;
                        }
                    }
                    .text1{
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 18px;
                        color: #999999;
                        text-align: center;
                    }
                   
                   
                    .btn_flex{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 37px;
                        .btns1{
                            width: 128px;
                            height: 40px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            cursor: pointer;
                            text-align: center;
                            line-height: 40px;
                        }
                        .btns2{
                            width: 128px;
                            height: 40px;
                            background: #377CFD;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-left: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>